import React, { Fragment } from 'react'
import { Alert, Tooltip } from '@mui/material'
import { ContentTooltipStudentInfo } from '../ContentTooltip/ContentTooltip'
import CustomAvatar from '../../../../../avatar/Avatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ItemMode = ({ item }) => {
  return (
    <Tooltip
      arrow
      placement='top'
      title={
        <Fragment>
          <ContentTooltipStudentInfo student={item} />
          {item.mode === 'error' && <Alert severity='error'>{item.message || 'An error ocurred'}</Alert>}
        </Fragment>
      }
    >
      <div
        className={[
          'flex gap-2 items-center justify-end  pl-4 pr-1 py-1 cursor-pointer',
          item.mode === 'error' ? 'bg-secondary' : 'bg-primary'
        ].join(' ')}
        style={{
          borderTopRightRadius: 30,
          borderBottomRightRadius: 30
        }}
      >
        <FontAwesomeIcon
          icon={item.mode === 'saving' ? 'circle-notch' : 'pencil'}
          spin={item.mode === 'saving'}
          className='text-primary-foreground'
        />
        <span className='uppercase text-primary-foreground font-bold'>{item.mode}</span>
        <CustomAvatar alt={item.code} src={`photos/${item.photo}`} size='small' />
      </div>
    </Tooltip>
  )
}

export default ItemMode
